(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dailies-clear-protein-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDcpHero(root) {
      if (!root || root.dataset.dcpInitialized) return;
      root.dataset.dcpInitialized = 'true';

      const swatches = root.querySelectorAll('[data-dcp-swatch]');
      const nameEl = root.querySelector('[data-dcp-flavor-name]');
      const noteEl = root.querySelector('[data-dcp-flavor-note]');
      const variantInput = root.querySelector('input[name="id"][ref="variantId"]');
      const form = root.querySelector('form[data-type="add-to-cart-form"]');
      const atcButton = root.querySelector('button.dcp-hero__atc');

      function setSelected(selected) {
        swatches.forEach((btn) => {
          const on = btn === selected;
          btn.classList.toggle('is-selected', on);
          btn.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (nameEl && selected.dataset.flavorName) {
          nameEl.textContent = selected.dataset.flavorName;
        }
        if (noteEl) {
          const note = selected.dataset.flavorNote || '';
          if (note) {
            noteEl.textContent = note;
            noteEl.hidden = false;
          } else {
            noteEl.textContent = '';
            noteEl.hidden = true;
          }
        }
        if (variantInput && selected.dataset.variantId) {
          variantInput.value = selected.dataset.variantId;
        }

        const available = selected.dataset.available === 'true';
        if (atcButton) {
          atcButton.disabled = !available;
        }
      }

      swatches.forEach((btn) => {
        btn.addEventListener('click', () => setSelected(btn));
      });
    }

    document.querySelectorAll('.dcp-hero').forEach(initDcpHero);

    document.addEventListener('shopify:section:load', (event) => {
      const el = event.target;
      if (!el || !el.querySelectorAll) return;
      el.querySelectorAll('.dcp-hero').forEach((node) => {
        delete node.dataset.dcpInitialized;
        initDcpHero(node);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
